<template>
  <div class="container mt-5">
    <b-row>
      <b-col md="12">
        <b-card style="height: 300px; overflow-y: auto">
          <b-form-input
            v-model="search"
            :placeholder="$t('ar_common_search')"
            class="mb-3"
          ></b-form-input>
          <b-form-checkbox
            v-model="selectAll"
            @change="toggleSelectAll"
            :class="{ 'ml-3': !isFlattenData }"
            class="mb-2 ml-1"
            ><span class="ml-1">{{ $t("ar_client_select_all") }}</span></b-form-checkbox
          >

          <!-- Hierarchical List -->
          <div v-for="item in filteredData" :key="item.Id">
            <div class="d-flex align-items-center">
              <ez-icon
                v-if="!isFlattenData"
                size="24"
                :icon="isCollapsed(item.Id) ? 'ezAr-icon-chevron-right' : 'ezAr-icon-chevron-down'"
                @click="toggleCollapse(item.Id)"
              />

              <b-form-checkbox
                style="margin-left: 12px"
                :value="item.Id"
                v-model="selectedParents"
                @change="selectParentChildren(item.Id)"
              ></b-form-checkbox>

              <h5 style="margin-left: 8px" class="mt-1">{{ item.NameVi }}</h5>
            </div>

            <b-collapse
              v-if="!isFlattenData"
              :id="'child-' + item.Id"
              :visible="!isCollapsed(item.Id)"
            >
              <b-list-group flush>
                <b-list-group-item v-for="childItem in item.Permission" :key="childItem.Id">
                  <b-form-checkbox class="ml-3" v-model="selectedData" :value="childItem">
                    <span class="ml-1">{{ childItem.NameVi }}</span>
                  </b-form-checkbox>
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
          </div>
        </b-card>
      </b-col>

      <!-- Selected Permissions Visualization Card -->
      <!--  <b-col md="6">
        <b-card style="width: 400px; height: 300px; overflow-y: auto">
          <div v-for="(rootItem, index) in selectedRootItems" :key="rootItem.Id" class="mb-2">
            <h5>{{ rootItem.NameVi }}</h5>
            <ul
              v-if="!isFlattenData"
              v-for="childItem in rootItem[`${childrensExpr}`]"
              :key="childItem.Id"
            >
              <li v-if="selectedDataIds.includes(childItem.Id)">{{ childItem.NameVi }}</li>
            </ul>
          </div>
        </b-card>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import Fuse from "fuse.js";

export default defineComponent({
  name: "ExchangeData",
  props: {
    initSelectedIds: {
      type: Array,
      default() {
        return [];
      },
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    isFlattenData: Boolean,
    childrensExpr: {
      type: String,
      default: "Permission",
    },
    searchExpr: {
      type: Array,
      default() {
        return ["NameVi", "Permission.NameVi"];
      },
    },
    displayExpr: {
      type: String,
      default: "NameVi",
    },
  },
  data() {
    return {
      selectAll: false,
      search: "",
      selectedData: [],
      selectedParents: [],
      collapsedIds: [],
    };
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.data.forEach((item) => {
          if (!this.isFlattenData) {
            item[`${this.childrensExpr}`].forEach((perm) => {
              if (!this.selectedDataIds.includes(perm.Id)) {
                this.selectedData.push(perm);
              }
            });
          } else {
            this.selectedData.push(item);
          }
        });
      } else {
        this.selectedData = [];
      }
    },
    selectParentChildren(funcId) {
      const rootData = this.data.find((func) => func.Id === funcId);
      if (!this.isFlattenData) {
        const relatedPermissions = rootData[`${this.childrensExpr}`];
        if (this.selectedParents.includes(funcId)) {
          relatedPermissions.forEach((perm) => {
            if (!this.selectedDataIds.includes(perm.Id)) {
              this.selectedData.push(perm);
            }
          });
        } else {
          relatedPermissions.forEach((perm) => {
            const index = this.selectedDataIds.indexOf(perm.Id);
            if (index !== -1) {
              this.selectedData.splice(index, 1);
            }
          });
        }
      } else {
        if (this.selectedParents.includes(funcId)) {
          this.selectedData.push(rootData);
        } else {
          const index = this.selectedDataIds.indexOf(rootData.Id);
          if (index !== -1) {
            this.selectedData.splice(index, 1);
          }
        }
      }
    },

    areAllChildrenSelected(funcId) {
      if (!this.isFlattenData) {
        const relatedPermissions = this.data.find((func) => func.Id === funcId)[
          `${this.childrensExpr}`
        ];
        return relatedPermissions.every((perm) => this.selectedDataIds.includes(perm.Id));
      } else {
        return this.selectedDataIds.includes(funcId);
      }
    },
    toggleCollapse(id) {
      if (this.collapsedIds.includes(id)) {
        this.collapsedIds = this.collapsedIds.filter((item) => item !== id);
      } else {
        this.collapsedIds.push(id);
      }
    },

    isCollapsed(id) {
      return this.collapsedIds.includes(id);
    },
  },
  computed: {
    selectedDataIds() {
      return this.selectedData.map((item) => item.Id);
    },
    filteredData() {
      const fuse = new Fuse(this.data, {
        keys: this.searchExpr,
        threshold: 0.3,
      });
      return this.search ? fuse.search(this.search).map((result) => result.item) : this.data;
    },
    selectedRootItems() {
      if (!this.isFlattenData) {
        return this.data.filter((func) =>
          func[`${this.childrensExpr}`].some((perm) => this.selectedDataIds.includes(perm.Id))
        );
      } else {
        return this.selectedData;
      }
    },
  },
  watch: {
    initSelectedIds: {
      handler(v) {
        this.selectedData = [];
        if (v.length > 0) {
          if (!this.isFlattenData) {
            this.data.forEach((item) => {
              item[`${this.childrensExpr}`].forEach((childItem) => {
                if (v.includes(childItem.Id)) {
                  this.selectedData.push(childItem);
                }
              });
            });
          } else {
            this.data.forEach((item) => {
              if (v.includes(item.Id)) {
                this.selectedData.push(item);
              }
            });
          }
          this.selectedParents = this.data
            .filter((func) => this.areAllChildrenSelected(func.Id))
            .map((func) => func.Id);
        }
        console.log(v, "2233");
      },

      deep: true,
      immediate: true,
    },
    selectedData: {
      handler(v) {
        this.selectedParents = this.data
          .filter((func) => this.areAllChildrenSelected(func.Id))
          .map((func) => func.Id);
      },
      deep: true,
    },
  },
});
</script>
